<div *ngIf="items?.length">
    <twc-list class="select-all-list">
        <twc-list-item>
            <div class="twc-list-item-col-1 twc-body">
                <twc-checkbox>
                    <input twcCheckboxInput [indeterminate]="selectionState === 'undefined'"
                        [checked]="selectionState === 'selectAll'" (change)="onSelectStateAllClicked($event)">
                    <label twcCheckboxLabel> {{allSelectionLabel | translate}}</label>
                </twc-checkbox>
            </div>
        </twc-list-item>
    </twc-list>

    <twc-list class="detail-list">
        <twc-list-item *ngFor="let item of items">
            <div class="twc-list-item-col-1">
                <twc-checkbox [ngClass]="{'font-bold': item.isBold}">
                    <input twcCheckboxInput [checked]="item.isSelected" (change)="onSelectElement(item)"
                        [disabled]="item.isDisabled">
                    <label twcCheckboxLabel>{{ item.label }}</label>
                </twc-checkbox>
            </div>
        </twc-list-item>
    </twc-list>
</div>